import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-stone-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function ControlRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-stone-400 bg-[#0F1115]">
        Loading…
      </div>
    );
  if (!user || !user.is_super_admin) return <Navigate to="/control/login" replace />;
  return children;
}

